import { render, staticRenderFns } from "./Page02.vue?vue&type=template&id=6037f699&scoped=true&"
import script from "./Page02.vue?vue&type=script&lang=js&"
export * from "./Page02.vue?vue&type=script&lang=js&"
import style0 from "./Page02.vue?vue&type=style&index=0&id=6037f699&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6037f699",
  null
  
)

export default component.exports